import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Col, Container, Row } from 'reactstrap';
import FormProfile from './components/FormProfile';
import history from '../../../history';

const ProfileConfiguration = (props) => {

  return (<Container className="dashboard">
    <Row>
      <Col md={12}>
        <div className="title-general-section">
          <h3>Configuración de perfil</h3>
        </div>
      </Col>
    </Row>
    <FormProfile />
  </Container>)
};

export default ProfileConfiguration;